import { render, staticRenderFns } from "./IconAccountInfo.vue?vue&type=template&id=135025ca&scoped=true"
import script from "./IconAccountInfo.vue?vue&type=script&lang=js"
export * from "./IconAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./IconAccountInfo.vue?vue&type=style&index=0&id=135025ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135025ca",
  null
  
)

export default component.exports